export const sessionStateTextKey = 'Session';

export type SessionStateText = {
    LoadingTitle: string;
    LoadingMessage: string;
    ContextErrorTitle: string;
    ContextErrorMessage: string;
    GenericErrorTitle: string;
    GenericErrorMessage: string;
    Retry: string;
    SelectCustomer: string;
};
